import FollowUpGapTimeSettingsTab from './follow-up-time-settings';

export default FollowUpGapTimeSettingsTab;
